(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dg-newsletter"]) return;
  try {
    
if (!customElements.get('dg-newsletter')) {
  customElements.define('dg-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.dialog = this.querySelector('dialog');
      this.badge = this.querySelector('.dgn-badge-wrap');
      const dismiss = () => {
        if (this.badge) this.badge.hidden = true;
        try { localStorage.setItem('dgn-badge-hidden-until', String(Date.now() + 7 * 86400000)); } catch {}
      };
      let hiddenUntil = 0;
      try { hiddenUntil = Number(localStorage.getItem('dgn-badge-hidden-until')) || 0; } catch {}
      if (this.querySelector('[data-dgn-success]')) { dismiss(); return; }
      if (!this.dialog || this.dataset.enabled !== 'true' || this.dataset.subscribed === 'true' || this.dataset.cart === 'true') return;
      if (this.badge) this.badge.hidden = hiddenUntil > Date.now();
      this.querySelector('[data-dgn-dismiss]')?.addEventListener('click', dismiss, {signal});
      this.querySelector('[data-dgn-open]')?.addEventListener('click', () => {
        if (!this.dialog.open) this.dialog.showModal();
      }, {signal});
      this.querySelectorAll('[data-dgn-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), {signal}));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const b = this.dialog.getBoundingClientRect();
        if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) this.dialog.close();
      }, {signal});
    }
    disconnectedCallback() { this.abort?.abort(); if (this.dialog?.open) this.dialog.close(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
